export default __webpack_public_path__ + "static/media/donation1.380b0333.png";